// File: src/components/StripeCancel.js

import React, { useContext, useEffect } from 'react';
import { useNavigate }                from 'react-router-dom';
import { jwtDecode }                  from 'jwt-decode';
import { AuthContext }                from '../user/AuthContext';

const StripeCancel = () => {
  const { user, setUser } = useContext(AuthContext);
  const navigate          = useNavigate();

  useEffect(() => {
    if (!user) {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setUser(decoded);
        } catch (err) {
          console.error('Token restore error:', err);
        }
      }
    }
  }, [user, setUser]);

  const handleReturn = () => {
    navigate('/profile/subscription');
  };

  return (
    <div
      style={{
        display:        'flex',
        flexDirection:  'column',
        alignItems:     'center',
        justifyContent: 'center',
        minHeight:      '100vh',
        textAlign:      'center',
        padding:        '1rem'
      }}
    >
      <h2>Payment Canceled</h2>
      <p>Your subscription process was canceled. You can try again anytime.</p>
      <button onClick={handleReturn}>Return to Subscription</button>
    </div>
  );
};

export default StripeCancel;
